export class UpdateWorkspaceStorageAccessConfigurationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateWorkspaceStorageAccessConfigurationInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateWorkspaceStorageAccessConfigurationInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceStorageAccessConfigurationInput.attributeTypeMap;
    }
    constructor() {
    }
}
